import type { JSX } from 'react'
import type { TextBoxColors } from 'atoms/TextBox'
import type { COLOR, FIXED_INDENTS, INDENTS, LABEL_INDENTS } from 'vars/index'
import type { Divider } from './List.h'

import React, { Fragment } from 'react'
import { LazyLoad } from 'blocks/Grid/components/LazyLoad/LazyLoad'
import { DividerStyled, ListStyled } from './List.styled'

export interface IListProps {
  children: React.ReactNode
  divider?: Divider
  wrap?: boolean
  width?: number
  direction?: 'row' | 'column'
  justifyContent?:
    | 'flex-start'
    | 'center'
    | 'flex-end'
    | 'space-between'
    | 'space-around'
    | 'space-evenly'
    | 'stretch'
  columnGap?: INDENTS | FIXED_INDENTS | LABEL_INDENTS
  rowGap?: INDENTS | FIXED_INDENTS
  color?: TextBoxColors
  alignItems?: 'flex-start' | 'flex-end' | 'center' | 'stretch'
  paddings?: FIXED_INDENTS[]
  onLoadMoreItems?: () => void
  height?: number
  backgroundColor?: COLOR
  flexGrow?: number
  flexShrink?: number
  margins?: FIXED_INDENTS[]
}

export const List = ({
  children,
  width,
  direction = 'row',
  justifyContent = 'flex-start',
  wrap,
  divider,
  columnGap,
  rowGap,
  color,
  alignItems,
  paddings,
  height,
  onLoadMoreItems,
  backgroundColor,
  flexGrow,
  flexShrink,
  margins,
}: IListProps): JSX.Element => {
  const WrapperComponentProps = onLoadMoreItems
    ? { onLoadMore: onLoadMoreItems, percentToTrigger: 75 }
    : {}
  const WrapperComponent = onLoadMoreItems ? LazyLoad : Fragment

  return (
    <ListStyled
      width={width}
      direction={direction}
      justifyContent={justifyContent}
      listWrap={wrap}
      divider={divider}
      rowGap={rowGap}
      columnGap={columnGap}
      colorDefault={color}
      alignItems={alignItems}
      paddings={paddings}
      height={height}
      backgroundColor={backgroundColor}
      flexGrow={flexGrow}
      flexShrink={flexShrink}
      margins={margins}
    >
      <WrapperComponent {...WrapperComponentProps}>
        {React.Children.map(children, (child, index) => {
          return (
            <>
              {child}
              {divider && index < React.Children.count(children) - 1 && (
                <DividerStyled divider={divider} data-type={divider} />
              )}
            </>
          )
        })}
      </WrapperComponent>
    </ListStyled>
  )
}
